import React from 'react';
import './MainContent.css';
import FilterButtons from '../FilterButtons/FilterButtons';

const MainContent = () => {
  return (
    <div className="main-content">
      <div className="main-content-container">
        {/* Title and Description */}
        <div className="content-header">
      
        </div>

        {/* Filter Buttons */}
        <FilterButtons />
      </div>
    </div>
  );
};

export default MainContent;